module.exports = __webpack_public_path__ + "media/images/pen_greenyellow-8011d464.png";